import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg text-primary-500 mb-4">蜜桃少年漫画</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              土豪漫画网旗下专业少年漫画阅读平台，提供漫画全集下拉式免费阅读服务。每日更新最新漫画章节，让您畅享阅读乐趣。
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-foreground-900 mb-4 text-sm">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-foreground-900 mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/shaonian-rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  少年热血
                </Link>
              </li>
              <li>
                <Link to="/category/lianai-qinggan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  恋爱情感
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-foreground-900 mb-4 text-sm">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@tuhaomanhua.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500"></i>
                <span>北京市朝阳区漫画大厦</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 土豪漫画网 - 蜜桃少年漫画 版权所有 | 京ICP备xxxxxxxx号
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="https://space.bilibili.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}